import {Component, ElementRef, ChangeDetectorRef, OnInit, ViewChild} from '@angular/core';
import {TooltipService} from "../core/services/tooltip.service";

@Component({
  selector: 'luv-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.css']
})
export class TooltipComponent implements OnInit {
  public options: any;
  public isVisible: boolean = false;
  public customStyle: string;
  @ViewChild('tooltipbox')
  public tooltipbox: ElementRef;

  constructor(
      private tooltipService: TooltipService,
      private cdRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.tooltipService.registerTooltipComponent(this);
  }

  public setOptions(optionsObject: any): void {
    this.options = {};
    for (let key in optionsObject) {
      this.options[key] = optionsObject[key];
    }
  }

  public getOptions(): any {
    return this.options;
  }

  public showTooltip(): void {
      this.isVisible = true;
      this.cdRef.detectChanges();
  }

  public hideTooltip(): void {
    this.isVisible = false;
  }

  public setCustomStyle(customStyle: string): void {
    this.customStyle = customStyle;
  }
};
